const trim = (value: string) => value.replace(/\/$/, "");
const configuredApi = import.meta.env.VITE_API_BASE_URL?.trim();
if (!configuredApi) throw new Error("VITE_API_BASE_URL must be configured.");
const api = trim(configuredApi);
export const config = Object.freeze({
  apiBase: api,
  signalRUrl: trim(import.meta.env.VITE_SIGNALR_URL?.trim() || `${api}/hubs/party`),
  version: __APP_VERSION__,
  buildSha: import.meta.env.VITE_BUILD_SHA ?? "local",
  diagnostics: import.meta.env.DEV && new URLSearchParams(location.search).has("diagnostics"),
});
